import { Directive, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  standalone: false,
  selector: '[appDisableControl]'
})
export class DisableControlDirective {

  @Input() set appDisableControl( condition: boolean ) {
    if (!this.ngControl.control) {
      return;
    }
    if (condition) {
      this.ngControl.control.disable();
    } else {
      this.ngControl.control.enable();
    }
  }

  constructor( private ngControl: NgControl ) {
  }
}
